import _ from "lodash";
import React from "react";
import classes from "./MiddleContainer.scss";
import classNames from "classnames";
import { LinkOutlined } from "@toddle-edu/ds-icons";
import { Alert } from "@toddle-edu/ds-web";

const renderRightPaneUI = ({ data }) => {
  switch (data.type) {
    case "title":
      return (
        <div className={classes.titleContainer} style={data.style}>
          <div className={"heading-5"}>{data.label}</div>
          {data.link && (
            <a className={classes.linkIconContainer} href={data.link}>
              <LinkOutlined size={"xxx-small"} variant={"subtle"} />{" "}
            </a>
          )}
        </div>
      );
    case "text":
      return (
        <div className={"text-body-1"} style={data.style}>
          {data.label}
        </div>
      );

    case "alert":
      return (
        <div style={data.style}>
          <Alert type={"info"} message={data.label} />
        </div>
      );
    case "definitions":
      return (
        <ul className={classes.definitionContainer} style={data.style}>
          {_.map(data.definitions, definition => {
            return (
              <div key={definition.key}>
                <li
                  className={classNames(
                    classes.definitionTitle,
                    "text-label-2"
                  )}
                >
                  {definition.title}
                </li>
                <li
                  className={classNames(
                    classes.definitionContent,
                    "text-body-1"
                  )}
                >
                  {definition.definition}
                </li>
              </div>
            );
          })}
        </ul>
      );
    case "custom":
      return <div style={data.style}>{data.content}</div>;
  }
};

const MiddleContainer = ({ rightPaneData, rightPaneMiddleContainerStyle }) => {
  return (
    <div
      className={classes.middleContainer}
      style={rightPaneMiddleContainerStyle}
    >
      {_.map(rightPaneData, data => {
        return <div key={data.key}>{renderRightPaneUI({ data })}</div>;
      })}
    </div>
  );
};

export default MiddleContainer;
